import { graphql } from 'gatsby'
import React, { useEffect, useState } from 'react'
import ColumnBackAndForth from '../../../components/atoms/columnBackAndForth'
import SEO from '../../../components/atoms/seo'
import { ITopicPath } from '../../../components/atoms/topicPath'
import ColumnAuthor002 from '../../../components/molecules/columnAuthor002'
import ColumnDetailInner0011 from '../../../components/molecules/columnDetailInner0011'
import UsefulFunctionLayout004 from '../../../components/molecules/usefulFunctionLayout004'
import ColumnDetailsBody from '../../../components/organisms/columnDetailsBody'
import ColumnLayout from '../../../components/organisms/columnLayout'
import Conclusion001 from '../../../components/molecules/Conclusion001'
import Conclusion004 from '../../../components/molecules/Conclusion004'
import Conclusion007 from '../../../components/molecules/Conclusion007'
import Conclusion002 from '../../../components/molecules/Conclusion002'
import Conclusion005 from '../../../components/molecules/Conclusion005'
import Conclusion008 from '../../../components/molecules/Conclusion008'
import Conclusion003 from '../../../components/molecules/Conclusion003'
import Conclusion006 from '../../../components/molecules/Conclusion006'
import Conclusion009 from '../../../components/molecules/Conclusion009'
import PopupBanner from '../../../components/molecules/popupBanner'
import CarouselBanner from '../../../components/molecules/carouselBanner'
import useRouteParam from '../../../hooks/useRouteParam'

/**
 * コラム記事詳細画面
 * @constructor
 */
const C0011 = () => {
  const paths: ITopicPath[] = [
    { title: 'キンクラコラムTOP', link: useRouteParam('/column') },
    { title: 'コラム記事一覧', link: useRouteParam('/column/list') },
    {
      title: '就業時間とは？労働時間や勤務時間との違いや正しい計算方法を解説',
    },
  ]
  // 0~8ランダム数字を保存
  const [no, setNo] = useState(-1)
  useEffect(() => {
    setNo(Math.floor(Math.random() * 9))
  }, [])

  return (
    <ColumnLayout paths={paths}>
      <SEO
        title="就業時間とは？概念や設定方法、賃金計算の仕方について解説"
        description="就業時間とは「業務の開始時間から修了時間までの通算した時間」のことです。法定労働時間内の範囲であれば、会社の状況に応じて自由に時間帯を設定できる制度です。"
        ogUrl="https://kintaicloud.jp/column/details/C0011/"
        ogType="article"
        ogTitle="就業時間とは？概念や設定方法、賃金計算の仕方について解説"
        ogDescription="就業時間とは「業務の開始時間から修了時間までの通算した時間」のことです。法定労働時間内の範囲であれば、会社の状況に応じて自由に時間帯を設定できる制度です。"
        ogSiteName="キンクラ - 客先常駐特化型のクラウド勤怠管理システム"
        ogImage="https://www.kintaicloud.jp/images/column/details/c0011.jpg"
      />
      <ColumnDetailsBody>
        {/** ポップアップバナー */}
        <PopupBanner />
        {/** 記事本体 */}
        <ColumnDetailInner0011 no={no} />
        {/** オーサ情報 */}
        <ColumnAuthor002 />

        {/** 記事本体 */}
        <ColumnDetailInner0011 no={no} />
        {/** オーサ情報 */}
        <ColumnAuthor002 />
        {/** ここに9パターンの広告設定する */}
        {no === 0 && <Conclusion001 />}
        {no === 1 && <Conclusion002 />}
        {no === 2 && <Conclusion003 />}
        {no === 3 && <Conclusion004 />}
        {no === 4 && <Conclusion005 />}
        {no === 5 && <Conclusion006 />}
        {no === 6 && <Conclusion007 />}
        {no === 7 && <Conclusion008 />}
        {no === 8 && <Conclusion009 />}

        {/** お役立ち機能 */}
        <UsefulFunctionLayout004 />
        {/** 前後記事への遷移 */}
        <ColumnBackAndForth />
        {/** カルーセルバナー */}
        <CarouselBanner />
      </ColumnDetailsBody>
    </ColumnLayout>
  )
}

export default C0011

export const pageQuery = graphql`
  query C0011 {
    site {
      siteMetadata {
        title
      }
    }
  }
`
